/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ContactsIcon from '@mui/icons-material/Contacts';
import { Card, CardHeader, Typography, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import { WidgetStyle } from "../../util/Styles";
import moment from "moment";
import "moment/locale/es";

const ContactList = (props) => {
  moment.locale("es");
  const history = useHistory();
  const [company, setCompany] = useState("");
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(0);
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setCompany(props.content.customer.name);
    setPage(props.content.page);
    setPages(props.content.pages);
    setTotal(props.content.total);
    setLimit(props.content.limit);
    setContacts(props.content.contacts);
  };

  const changePage = async (type) => {
    let body = {
      uuid: props.content.customer.uuid,
      limit: limit,
      page: 0,
    };

    if (type == "next") {
      body.page = page + 1;
    }
    if (type == "prev") {
      body.page = page - 1;
    }

    contactList(body);
  };

  const contactList = async (request) => {
    props.changeLoader(true);
    let widgets = await API.service( "contactList", request, props.pos, props.changeAlert, props.changeLoader, history);
    if (widgets.status == 200 && widgets.data.data.response == "OK") {
      props.changeWidgets(widgets.data.data.widget);
    }
    props.changeLoader(false);
  };

  const infoPersonal = async (uuid, email, clabe) => {
    let find = {
      data: {
        customer: {
          keyword: email ? email : clabe
        },
        filters: {
          results_per_page: 50,
          page_number: 1,
          search_type: email ? "email" : "clabe"
        }
      }
    }
    props.addWidget("dataPersonal", find, ["changeEmail"], find);
  };

  const columns = [
    {
      cell: (item) => {
        if (item.general.type && item.general.type == "domestic") {
          return (
            <a data-tag="allowRowEvents"
              onClick={infoPersonal.bind(
                this, item.customer_uuid, item.general.email, item.general.account.clabe ? item.general.account.clabe : item.general.account.reference
            )}
            ><VisibilityIcon /></a>
          );
        } else {
          return <VisibilityOff style={{ color: "gray" }} />;
        }
      },
      sortable: true, width: "4%",
    },
    { selector: (row) => row.general.name, name: "Nombre completo", width: "16%", wrap: true, sortable: true },
    { selector: (row) => moment(new Date(row.cdate)).format("L"), name: "Creación", width: "11%", wrap: true, sortable: true },
    { selector: (row) => row.general.email ? row.general.email : "" , name: "Correo electrónico", width: "18%", wrap: true, sortable: true },
    { selector: (row) => row.general.account.clabe ? row.general.account.clabe : row.general.account.reference, name: "CLABE", width: "19%", wrap: true, sortable: true },
    { selector: (row) => row.general.phone ? row.general.phone : "", name: "Teléfono", width: "16%", wrap: true, sortable: true },
    { selector: (row) => row.general.category ? row.general.category : "", name: "Tipo de Contacto", width: "15%", wrap: true, sortable: true },
  ];

  return (
    <WidgetStyle property={"false"}>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Card sx={{width: '100% !important', padding: 3}}>
            <CardHeader
              sx={{marginBottom: 2}}
              title={
                <div style={{display: 'inline-flex'}}>
                  <ContactsIcon/>
                  <Typography
                    component={'h3'}
                    fontSize="20px"
                    fontWeight={600}
                    sx={{color: '#3E3E42', padding: "0 14px"}}>
                      Contactos {company}
                  </Typography>
                </div>
              }
              />
      
              {/* Paginacion -----------------------------------> */}
              <div style={{textAlign: "end", margin: "1rem 0"}}>
                <span className="neutral">
                  {1 + (page - 1) * limit} -{" "}
                  {limit * page <= total ? limit * page : total} de {total}
                </span>
                {1 + (page - 1) * limit > 1 && (
                  <i className="tap ibon-chevron-left indigo"
                    onClick={changePage.bind(this, "prev")} />
                )}
                {limit * page < total && (
                  <i className="tap ibon-chevron-right indigo"
                    onClick={changePage.bind(this, "next")} />
                )}
              </div>    
            
              <div style={{ width: "100%", margin: "auto" }}>        
                <DataTable
                  columns={columns}
                  data={contacts}
                  customStyles={customStyles2}
                  noDataComponent={noDataComponent}
                />
              </div>
          </Card>
        </Grid>
      </ThemeProvider>
    </WidgetStyle>
  );
};

export default ContactList;
